// =========================================================
// Footer.jsx
// ORION BEACH HOTEL · GUAJIRA
// FOOTER PREMIUM
// =========================================================

import "../styles/footer.css";


export default function Footer() {

  const year =
    new Date().getFullYear();


  // =======================================================
  // SCROLL TO SECTION
  // =======================================================

  const scrollToId = (id) => {

    const element =
      document.querySelector(id);


    if (element) {

      element.scrollIntoView({

        behavior:
          "smooth",

        block:
          "start",

      });

    }

  };


  // =======================================================
  // RENDER
  // =======================================================

  return (

    <footer className="footer">


      {/* =====================================================
          DECORATIVE TOP LINE
      ===================================================== */}

      <div className="footer__top-line">

        <span></span>

      </div>


      {/* =====================================================
          MAIN FOOTER
      ===================================================== */}

      <div className="footer__container">


        {/* =================================================
            BRAND
        ================================================= */}

        <div className="footer__brand">


          {/* =================================================
              LOGO
          ================================================= */}

          <button
            type="button"

            className="footer__logo"

            onClick={() =>
              scrollToId("#hero")
            }

            aria-label="Volver al inicio"
          >

            <img
              src="/images/logo-orion.png"
              alt="Hotel Orión Guajira"
              className="footer__logo-image"
            />

          </button>


          {/* =================================================
              DESCRIPTION
          ================================================= */}

          <p className="footer__description">

            Un lugar para desconectarte,
            descansar y vivir la magia
            de La Guajira.

          </p>


          {/* =================================================
              LOCATION
          ================================================= */}

          <div className="footer__location">

            <span
              className="
                footer__location-icon
              "
            >
              ◇
            </span>

            <span>
              La Guajira · Colombia
            </span>

          </div>

        </div>


        {/* =================================================
            NAVIGATION
        ================================================= */}

        <div className="footer__column">

          <h4>
            Explora
          </h4>


          <button
            type="button"
            onClick={() =>
              scrollToId("#hero")
            }
          >
            Inicio
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#habitaciones")
            }
          >
            Habitaciones
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#servicios")
            }
          >
            Servicios
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#galeria")
            }
          >
            Galería
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#ubicacion")
            }
          >
            Ubicación
          </button>

        </div>


        {/* =================================================
            INFORMATION
        ================================================= */}

        <div className="footer__column">

          <h4>
            Hotel
          </h4>


          <button
            type="button"
            onClick={() =>
              scrollToId("#historia")
            }
          >
            Sobre Orión
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#experiencias")
            }
          >
            Experiencias
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#contacto")
            }
          >
            Contacto
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToId("#reservas")
            }
          >
            Reservaciones
          </button>

        </div>


        {/* =================================================
            CONTACT / BOOKING
        ================================================= */}

        <div
          className="
            footer__column
            footer__column--contact
          "
        >

          <h4>
            Reserva tu estadía
          </h4>


          <p>

            Vive una experiencia única
            en el corazón de La Guajira.

          </p>


          {/* =================================================
              BOOKING BUTTON
          ================================================= */}

          <a
            href="#ubicacion"

            className="
              footer__booking
            "

            onClick={(event) => {

              event.preventDefault();

              scrollToId("#ubicacion");

            }}
          >

            <span>
              Cómo llegar
            </span>

            <span
              className="
                footer__booking-arrow
              "
            >
              →
            </span>

          </a>


          {/* =================================================
              SOCIAL
          ================================================= */}

          <div className="footer__socials">

            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              Instagram
            </a>


            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              Facebook
            </a>

          </div>

        </div>

      </div>


      {/* =====================================================
          DIVIDER
      ===================================================== */}

      <div className="footer__divider"></div>


      {/* =====================================================
          BOTTOM
      ===================================================== */}

      <div className="footer__bottom">


        <p>

          © {year} Hotel Orión Guajira.
          Todos los derechos reservados.

        </p>


        <div className="footer__legal">

          <a
            href="/politica-privacidad"
          >
            Privacidad
          </a>

          <span>
            •
          </span>

          <a
            href="/terminos"
          >
            Términos
          </a>

        </div>


        <p className="footer__dev">

          Diseñado y desarrollado por{" "}

          <a
            href="https://clubdelapelea.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Club de la Pelea
          </a>

        </p>

      </div>

    </footer>

  );

}